// extracted by mini-css-extract-plugin
export var card = "_88-1";
export var container = "_88-0";